import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { menuData } from '../../data/menuData';
import './MenuSection.css';

const MenuSection = ({ menuType }) => {
  const { language } = useLanguage();
  const menu = menuData[menuType];

  if (!menu) return null;

  const getText = (obj) => {
    if (!obj) return '';
    return obj[language] || obj.fr || '';
  };

  const categories = Array.isArray(menu.categories) ? menu.categories : [];

  return (
    <div className="menu-section">
      {categories.map((category, catIndex) => (
        <div key={catIndex} className="menu-category">
          <h3 className="category-title">{getText(category.name)}</h3>
          <div className="menu-items">
            {(Array.isArray(category?.items) ? category.items : []).map((item, itemIndex) => (
              <div key={itemIndex} className="menu-item">
                <div className="menu-item-header">
                  <div className="item-text">
                    <h4 className="item-name">{getText(item.name)}</h4>
                    <p className="item-description">{getText(item.description)}</p>
                  </div>
                  <span className="item-price">{item.price} DT</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default MenuSection;









